<template>
  <div class="wrap">
    <Nav :title="$t('newAdd.withdrawRecord')" fixed safeAreaInsetTop placeholder />
    <!-- <div class="tab-lists">
      <div class="tab-item" :class="[status === item.params.status ? 'on-tab-item' : '']"
        v-for="(item, index) in tabLists" :key="index" @click="handleTabItme(item.params.status)">
        {{ item.title }}
      </div>
    </div> -->
    <div class="content">
      <List url="/users/extract/record" :initParams="{ status: status }" ref="listRef" listWrapClass="list">
        <template #item="{ item }">
          <!-- <div class="list-item">
            <div class="list-item-left">
              <div class="list-item-title">
                <span class="list-item-title-text">{{ item.bankinfo.name }}</span>
                <span v-if="item.status === '已汇款'" class="list-item-title-sub">（{{ stateObj[item.status] }}）</span>
                <span v-else class="list-item-title-sub-green">（{{
                  item.retrun == '1'
                    ? 'Failed-balance returned'
                    : stateObj[item.status]
                }}）</span>
              </div>
              <div>
                <span v-if="item.status === '未通过' && item.reason" class="list-item-reason">{{$t('原因')}}{{ item.reason
                }}</span>
              </div>
              <span class="list-item-bank" v-if="item.coin_type && item.coin_type !== ''">{{
                `${$t('newAdd.Amount')}: ${item.coin_num}${item.coin_type}`
              }}</span>
              <span class="list-item-bank" v-else>{{ item.bankinfo.bank }}{{ $t('tailNumber') }}
                {{ item.bankinfo.card_l4 || '' }}</span>
              <div class="list-item-indate">{{ $format(item.indate) }}</div>
            </div>
            <div class="list-item-right">
              <span class="list-item-money">{{ item.money }}</span>
            </div>
          </div> -->

          <div class="lists">
            <div class="list_item">
              <div class="label">{{ $t('orderNo') }}:</div>
              <div class="value">{{ item.id }}</div>
            </div>
            <div class="list_item">
              <div class="label">{{ $t('提现时间') }}:</div>
              <div class="value">{{ $format(item.indate,'dd/MM/yyyy HH:mm:ss') }}</div>
            </div>
            <div class="list_item">
              <div class="label">{{ $t('提现金额') }}:</div>
              <div class="value">{{ item.money }}</div>
            </div>
            <div class="list_item">
              <div class="label">{{ $t('状态') }}:</div>
              <template v-if="item.reason">
                <div class="filed">{{ item.reason }}</div>
              </template>
              <div class="value" :style="item.status == '未通过' ? { 'color': 'red' } : { color: 'green' }" v-else>{{ $t(item.status) }}
              </div>
            </div>
          </div>

        </template>
      </List>
    </div>
  </div>
</template>

<script>
import { cell, icon, field, Dialog, Toast } from 'vant'
import { GET_WITHDRAW_LISTS } from '@/api'
import { formatDate } from '@/utils/tools'
import Nav from "@/components/Navbar";
import List from "@/components/List";
export default {
  components: {
    [cell.name]: cell,
    [icon.name]: icon,
    [field.name]: field,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    Nav,
    List
  },
  data() {
    return {
      status: 0,
      tabLists: [
        {
          // language-ch 全部 
          title: this.$t('AllOut'),
          params: { status: 0 },
        },
        {
          // language-ch 审核中
          title: this.$t('newAdd.reviewing'),
          params: { status: 1 },
        },
        {
          // language-ch 已汇款
          title: this.$t('newAdd.remittance'),
          params: { status: 4 },
        },
        {
          // language-ch 未通过
          title: this.$t('newAdd.notThrough'),
          params: { status: 5 },
        },
      ],
      stateObj: {
        已汇款: 'success',
        未通过: 'not pass',
        汇款中: 'processing',
        idpay: 'Pay on behalf of',
      },
    }
  },
  mounted() { },
  methods: {
    handleTabItme(status) {
      this.status = status
      this.$nextTick(() => {
        this.$refs.listRef && this.$refs.listRef.handleRefresh();
      })
    },
    dateEvent(indate) {
      return formatDate('MM/dd/yyyy HH:mm:ss', indate)
    },
  },
}
</script>

<style scoped lang="less">
@background: var(--nav-background);
@color: var(--theme);

.wrap {
  flex: 1;
  width: 100%;
  height: 100vh;
  background-color: #f4f8f9;

  .tab-lists {
    display: flex;
    align-items: center;
    background-color: var(--white);

    .tab-item {
      width: 33.33%;
      height: calc(40rem / 16);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: calc(14rem / 16);
      color: #6a6a6a
    }

    .on-tab-item {
      color: var(--bg)
    }
  }

  .content {
    padding: calc(20rem / 16) calc(10rem / 16);
  }
}

/deep/ .van-list {
  .list {
    padding-bottom: calc(16rem /16);
  }
}

.list-item {
  padding: calc(16rem / 16);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: var(--white);
  border-radius: calc(4rem / 16);
}

.list-item-title {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.list-item-title-text {
  font-size: calc(23rem / 16);
  color: #242424;
}

.list-item-title-sub,
.list-item-title-sub-green {
  font-size: calc(12rem / 16);
  color: #1bb019;
}

.list-item-title-sub-green {
  color: @color;
}

.list-item-reason {
  margin-top: calc(6rem / 16);
  font-size: calc(12rem / 16);
  color: @color;
  width: calc(520rem / 16);
}

.list-item-bank {
  margin-top: calc(6rem / 16);
  font-size: calc(12rem / 16);
  color: #888888;
}

.list-item-indate {
  margin-top: calc(6rem / 16);
  font-size: calc(12rem / 16);
  color: #888888;
}

.list-item-right {
  align-items: flex-end;
}

.list-item-order {
  font-size: calc(10rem / 16);
  color: #999999;
}

.list-item-money {
  margin-top: calc(6rem / 16);
  font-size: calc(17rem / 16);
  color: @color;
}

.lists {
  background: var(--white);
  border-radius: 8px;
  padding: 10px;

  .list_item {
    border-bottom: 1px dashed #d9d9d9;
    padding: 10px 0;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .label {
      color: #333;
    }

    .value {
      color: #000;
    }
    .filed{
      color: red;
      max-width: 50%;
      text-align: right;
      text-wrap: wrap;
      overflow-wrap: break-word;
    }
  }

  .list_item:last-child {
    border: none;
  }
}
</style>